export default __webpack_public_path__ + "static/media/email-msg.f21bcbdd.png";